import screens from "../assets/screens.png";
import { texts } from "../data/langs";
import feather from "feather-icons";
import "../App.css";

export const Contact = (props) => {
  const { setContact } = props;
  const toggleContact = () => {
    setContact((e) => false);
  };

  const conversionFn = () => {
    window.gtag &&
      window.gtag("event", "conversion", {
        send_to: "AW-17225078986/gNAbCLef2d0aEMqxx5VA",
      });
  };

  return (
    <section className="overlay " id="Contact">
      <div className="modal center_all">
        <h2>{texts[texts.active].contact.title}</h2>
        <span>{texts[texts.active].contact.subtitle}</span>

        <div className="GAP-20 " />

        <h3>{texts[texts.active].contact.h3A}</h3>
        <span>{texts[texts.active].contact.span1}</span>

        <div className="GAP-10 " />

        <a
          onClick={conversionFn}
          href="https://api.whatsapp.com/send?phone=5511916745093&text=Olá%2C+vi+seu+anúncio+no+Google+e+quero+mais+informações+sobre+o+desenvolvimento+de+software."
          target="_blank"
          className="btn2"
          style={{ width: 190 }}
        >
          {texts[texts.active].contact.btn1}
        </a>

        <div className="GAP-20 " />

        <h3>{texts[texts.active].contact.h3B}</h3>
        <span>{texts[texts.active].contact.span2}</span>

        <div className="GAP-10 " />

        <a
          //   onClick={conversionFn}
          href="https://api.whatsapp.com/send?phone=5511916745093&text=Quero%20tirar%20d%C3%BAvidas%20sobre%20outras%20oportunidades%20de%20neg%C3%B3cio."
          target="_blank"
          className="btn2"
          style={{ width: 190 }}
        >
          {texts[texts.active].contact.btn2}
        </a>

        <button
          id="closeMenu"
          className="btn3"
          onClick={toggleContact}
          style={{ position: "absolute", top: 4, right: 4 }}
        >
          <div
            style={{ width: "auto" }}
            dangerouslySetInnerHTML={{
              __html: feather.icons["x"].toSvg({
                class: "foo bar",
                "stroke-width": 3,
                stroke: "#999",
                width: 16,
                height: 16,
              }),
            }}
          />
        </button>
      </div>
    </section>
  );
};
